import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-badge',
  templateUrl: './manage-badge.component.html',
  styleUrls: ['./manage-badge.component.scss']
})
export class ManageBadgeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
